(function () {
  var configElement = document.getElementById('tiktok-flex-config');
  if (!configElement || configElement.dataset.initialized) return;
  configElement.dataset.initialized = 'true';
  var config = JSON.parse(configElement.textContent);
  var lastCheckout = { url: '', time: 0 };

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-fragile-checkout-url]');
    if (!link || event.defaultPrevented || event.button !== 0) return;
    if (document.documentElement.hasAttribute('data-flex-billing-pending') ||
      link.hasAttribute('data-flex-billing-checkout-unavailable') ||
      link.getAttribute('aria-disabled') === 'true') return;
    var destination = new URL(link.href, window.location.href);
    if (destination.hostname !== 'flex.nzxt.com' || !/^\/nzxt\/checkout\/?$/.test(destination.pathname)) return;
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;
    var now = Date.now();
    if (lastCheckout.url === destination.href && now - lastCheckout.time < 1500) return;
    lastCheckout = { url: destination.href, time: now };
    var properties = config.product ? {
      content_type: 'product',
      contents: [{
        content_id: config.product.id,
        content_name: config.product.title,
        quantity: 1
      }]
    } : {};
    analytics.publish('nzxt_flex_checkout_started', properties);
  });
}());
